import { CalendarColumnBodyVariant, CalendarEventType } from './types';

export const CALENDAR_GRID_TIME_FORMAT = 'h:mm A'; // 12-hour format with AM/PM

export const MIN_COLUMN_WIDTH: Record<CalendarColumnBodyVariant, number> = {
  stacked: 50,
  grid: 200,
};

export const CALENDAR_Z_INDICES = {
  debugControls: 100,
  dragCreateSelectionOverlay: 100,
  topCornerCell: 100, // above all other cells
  groupHeader: 90,
  timeColumn: 80,
  currentTimeIndicatorBadge: 85,
  currentTimeIndicatorLine: 75,
};

export const EVENT_Z_INDICES: Record<CalendarEventType, number> = {
  // Background blocks — lowest layer
  unavailableBlock: 30,
  availableBlock: 30,
  exception: 30,
  // Schedule templates — above blocks, below events
  scheduleDefinition: 40,
  // Pending / secondary events
  cancelledAppointment: 50,
  appointment: 50,
  scheduleRequest: 51,
  // UI controls — topmost event layer
  availabilitySlot: 60,
  nonInteractiveSlot: 60,
  slotsStartLabel: 60,
};

export const PX_PER_MINUTE = 2; // 1 minute = 2px, so 15 minutes = 30px
export const TOTAL_HOURS = 24;
